// ===== Packages =====

import {
    getFunctions,
    httpsCallable,
}                               from 'firebase/functions';

// ===== Services =====
import getCurrentActionOrigin    from './getCurrentActionOrigin';

// ===== Interfaces =====

import {
    IClaimBookInvitePayload,
    IClaimBookInviteResult,
}                               from '../interfaces';

const claimBookInvite = async ({
    test,
    ownerUserId,
    assignmentId,
    claimToken,
    firstName,
    lastName,
}: {
    test: boolean,
    ownerUserId: string,
    assignmentId: string,
    claimToken: string,
    firstName?: string,
    lastName?: string,
}): Promise<IClaimBookInviteResult> => {
    const functions = getFunctions();
    const callable = httpsCallable<
        IClaimBookInvitePayload,
        IClaimBookInviteResult
    >(
        functions,
        'claimBookInvite',
    );
    const actionOrigin = getCurrentActionOrigin();
    const payload: IClaimBookInvitePayload = {
        test,
        ownerUserId,
        assignmentId,
        claimToken,
        firstName,
        lastName,
    };
    if (actionOrigin) payload.actionOrigin = actionOrigin;
    return callable(payload).then((result) => result.data as IClaimBookInviteResult);
};

export default claimBookInvite;
